var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.2831L27.4405 0.506104L55.6199 10.1092L51.0572 46.4143L27.4405 59.4937L4.19324 46.5881L0 10.2831Z",
    fill: "#E23237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6199 10.1095L27.4404 0.506348V59.494L51.0572 46.4364L55.6199 10.1095Z",
    fill: "#B52E31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4839 7.39355L10.3853 45.4368L16.7727 45.3282L20.2056 36.746H35.5445L39.3032 45.4368L45.4083 45.5454L27.4839 7.39355ZM27.5275 19.5822L33.3066 31.662H22.4433L27.5275 19.5822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory1);
export default __webpack_public_path__ + "static/media/category-1.37b8607abd1fafc83375732607ec05fd.svg";
export { ForwardRef as ReactComponent };